import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { enableProdMode } from '@angular/core';
enableProdMode();

/* External Components */
import { GrowlModule } from 'primeng/primeng';
import { CalendarModule } from 'primeng/primeng';
import { DialogModule } from 'primeng/primeng';
import { FileUploaderModule } from '../file-uploader/file-uploader.module';

/* Routing Provider */
import { SchoolInformationRoutingProvider } from './school-information.routes';

import { SchoolInformationAddComponent } from './school-information-add.component';
import { SchoolInformationEditComponent } from './school-information-edit.component';
import { SchoolInformationForClientComponent } from './school-information-for-client.component';


@NgModule({
    imports: [
        BrowserModule, FormsModule,
        SchoolInformationRoutingProvider, CalendarModule, DialogModule,
        GrowlModule,
        BrowserAnimationsModule,
        FileUploaderModule 
    ],
    declarations: [
        SchoolInformationAddComponent,
        SchoolInformationEditComponent,
        SchoolInformationForClientComponent
        
    ],
    providers: [],
    exports: [SchoolInformationForClientComponent]
})
export class SchoolInformationModule { }
